<template>
  <div class="gs-app gm-suppression-table pb-4 text-dark">
    <div class="gm-suppression-table__surface gs-refresh-controls flex mb-4">
      <div class="w-full">
        <server-table
          class="text-center groovemail-unsubscribers-table"
          :url="unsubscribersUrl"
          ref="serverTable"
          tableRef="unsubscribersTable"
          :slotData="unsubscribersTableSlotData"
          :tableColumns="unsubscribersTableColumns"
          :tableOptions="unsubscribersTableOptions"
          tableTitle="frontend_groovemail_components_suppressions_unsubscribers"
          addNewBtnText="frontend_groovemail_suppressions_unsubscribers_add_new_unsubscriber"
          @addNewData="openAddUnsubscriberModal"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </div>
    </div>
    <gd-modal
      id="unsubscribersModal"
      name="unsubscribers-modal"
      :title="
        $t('frontend_groovemail_suppressions_unsubscribers_add_new_unsubscriber')
      "
    >
      <AddUnsubscriber
        @closeUnsubscribersModal="closeAddUnsubscriberModal"
        @refreshUnsubscribersListing="refreshUnsubscribersListing"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
      ></AddUnsubscriber>
    </gd-modal>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-chnage-unsubscriber`"
      :name="`confirmation-chnage-unsubscriber`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="messageContent"
      @confirm="changeUnsubscriberStatus"
      @close="closeChnageUnsubscriberModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { postData } from '@/utils/apiHelper.js';
import { suppressorsUrl } from '@/utils/urls.js';
import AddUnsubscriber from './add-unsubscribers.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

import { showRequestErrorAlert } from '@/components/showDialog.js';

let self;

export default {

  mixins: [demoModeValuesMixin],

  data() {
    return {
      tableKey: 1,
      unsubscribersUrl: suppressorsUrl.unsubscribers,
      unsubscribersTableColumns: ['email', 'list_count', 'actions'],
      unsubscribersTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        filterable: ['email'],
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['email'],
        headings: {
          email: () =>
            this.$t(
              'frontend_groovemail_components_suppressions_unsubscribers_email_header'
            ),
          list_count: () =>
            this.$t('frontend_groovemail_components_suppressions_no_of_lists'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        requestFunction(data) {
          const self = this;
          return axios
            .get(self.url, {
              params: data,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },

      messageContent: '',
      unsubscriberTarget: {},
      targetUrl: '',
    };
  },

  created(){
    self = this;
  },

  watch: {
    // Used to refresh black list table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.unsubscribersTable.refresh();
    },
  },

  methods: {
    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader (){
      this.$emit('hideLoader');
    },

    /**
     * Used to make an unsubscriber as complainer.
     * @param {object} unsubscriber unsubscriber data.
     */
    async moveToComplainer(unsubscriber) {
      await this.openChnageUnsubscriberModal(
        unsubscriber,
        1,
        suppressorsUrl.addUnsubscribersToComplainers
      );
    },
    
    /**
     * Used to make an unsubscriber as suppressor.
     * @param {object} unsubscriber unsubscriber data.
     */
    async moveToSupressions(unsubscriber) {
      await this.openChnageUnsubscriberModal(
        unsubscriber,
        2,
        suppressorsUrl.addComplainersToSupression
      );
    },


    // open delete Recipients modal
    async openChnageUnsubscriberModal(unsubscriber, toStatus, url) {
      // set the message content
      this.messageContent = toStatus === 1
        ? this.$t('frontend_groovemail_suppressions_move_unsubscribers_to_complainer')
        : this.$t('frontend_groovemail_suppressions_move_unsubscribers_to_supressions');

      // set the unsubscriber
      this.unsubscriberTarget = unsubscriber;

      // set the target url
      this.targetUrl = url;

      // open the modal
      this.$refs[`confirmation-chnage-unsubscriber`].open();
    },

    // close delete Recipients modal
    closeChnageUnsubscriberModal() {
      // reset the all values
      this.messageContent = '';
      this.unsubscriberTarget = {};
      this.targetUrl = '';

      // close the modal
      this.$refs[`confirmation-chnage-unsubscriber`].close();
    },


    // Used to change unsubscriber status
    async changeUnsubscriberStatus() {
      // show the loader
      this.showLoader();

      try {
        await postData(this.targetUrl, {
          lead_id: this.unsubscriberTarget.lead_id,
          email: this.unsubscriberTarget.email,
        });

        this.refreshUnsubscribersListing();
      } catch (error) {
        // show the error message
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    // Used to open create unsubscriber modal
    openAddUnsubscriberModal() {
      this.$root.$emit('modal-open', 'unsubscribers-modal');
    },

    // Used to close create unsubscriber modal
    closeAddUnsubscriberModal() {
      this.$root.$emit('modal-close', 'unsubscribers-modal');
    },

    // Used to refresh unsubscriber's listing data
    refreshUnsubscribersListing() {
      this.$refs.serverTable.$refs.unsubscribersTable.refresh();
    },
  },

  computed: {
    /**
     * Returns unsubscribers table slot data.
     * @return {array} - slot data for unsubscribers table 
     */
    unsubscribersTableSlotData() {
      return [
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: (props) => {
            return {
              outerDiv:
                props.row.is_complainer && props.row.is_suppression
                  ? 'cursor-not-allowed'
                  : '',
              dropdown:
                props.row.is_complainer && props.row.is_suppression
                  ? 'opacity-50 pointer-events-none'
                  : '',
              outerSpan:
                props.row.is_complainer && props.row.is_suppression
                  ? 'bg-grey-300'
                  : '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => `${this.$t(
                'frontend_groovemail_components_suppressions_add_to'
              )} ${this.$t(
                'frontend_groovemail_components_suppressions_complainers'
              )}`,
              conditions: (props) => {
                return !props.is_complainer;
              },
              callback: (props) => this.moveToComplainer(props.row),
            },
            {
              id: 1,
              name: () => `${this.$t(
                'frontend_groovemail_components_suppressions_add_to'
              )} ${this.$t(
                'frontend_groovemail_suppressions_route_page_title'
              )}`,
              conditions: (props) => {
                return !props.is_suppression;
              },
              callback: (props) => this.moveToSupressions(props.row),
            },
          ],
        },
      ];
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
  },

  components: {
    AddUnsubscriber,
    ServerTable,
  },
};
</script>

<style scoped>
.gm-suppression-table__surface {
  min-width: 0;
  padding: 20px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-suppression-table__surface {
    padding: 14px;
    border-radius: var(--gs-radius-md);
  }
}
</style>
